
<div class="modal-header sticky-header">

  <div class="row">
    <h5 class="modal-title align-self-center col" id="profileModalLabel">Settings - {{title}}</h5>
    <div class="col-auto text-end pt-3">
      <button class="btn btn-secondary me-2" type="button" (click)="close()"><i class="fa fa-times"></i> Cancel</button>
      <button type="button" class="btn btn-primary btn-primary-color" (click)="save()">
       <i class="fa fa-save"></i> Save
      </button>
    </div>
  </div>
</div>
<div class="modal-body">
  <div *ngFor="let groupId of groupedNotificationTypes | keyvalue;let i = index">
    <div class="d-flex">
      <mat-checkbox [checked]="areAllSelected(groupId.key)" [indeterminate]="hasSelection(groupId.key) && !areAllSelected(groupId.key)" (change)="toggleSelectAll($event, groupId.key)">
        <div class="ms-4 fs-5">
          <strong>{{ groupedNotificationTypes[groupId.key][0].notificationGroupName }}</strong>
        </div>
      </mat-checkbox>
    </div>
    <hr class="mb-2 mt-2" />
    <div *ngFor="let type of groupId.value">
      <div class="d-flex ps-3">
        <mat-checkbox [checked]="selectedTypeIds.has(type.notificationTypeId)"
                      (change)="toggleSelection(type.notificationTypeId)">

          <div class="ms-4 d-flex flex-direction-column text-wrap">
            <strong>{{ type.name }}</strong>
            <span>{{ type.description }}</span>
          </div>

        </mat-checkbox>
      </div>
    </div>
    <hr class="fullwidth-hr" />
  </div>

</div>

